import script from "./ip-access-event-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./ip-access-event-list.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__